import SummaryRouter from './SummaryRouter';
import SummaryRouterConnector from './SummaryRouterConnector';

const ConnectedComponent = () => <SummaryRouterConnector component={SummaryRouter} />;

export default ConnectedComponent;
